<template>
  <div class="elevation-6 initial-card pt-2">
    <v-container>
        <v-content v-if="!recoverSuccess">
            <div class="d-flex justify-center flex-column mt-6">
                <img :src="require('@/assets/icons/password.svg')" alt="logo">
                <span class="headline grey-darken--text text--darken-3 text-center pt-2 font-weight-bold">Esqueci minha senha</span>
            </div>
            <div class="subtitle-1 grey--text text--darken-3 px-12 py-4 text-center">
                Preencha com seu e-mail cadastrado para receber uma mensagem com as intruções de como redefinir sua senha.
            </div>
            <div class="px-12">
                <v-form
                    ref="form"
                    v-model="valid"
                    class="d-flex flex-column align-center justify-center"
                    >
                    <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail cadastrado"
                        required
                        class="fluid"
                    ></v-text-field>

                    <div class="fluid d-flex justify-center">
                        <v-btn
                            :disabled="!valid"
                            color="#1c579a"
                            class="white--text button-primary elevation-2 mt-6"
                            @click="send();"
                        >
                            Enviar
                        </v-btn>
                    </div>

                    <router-link to="/login" class="light-blue--text text--darken-4 body-2 decoration-none mt-8">Retornar para Login</router-link>
                </v-form>
            </div>
        </v-content>
        <v-content v-else>
            <div class="d-flex justify-center flex-column">
                <img src="../assets/icons/password.svg" alt="">
                <span class="headline light-blue--text text--darken-4 text-center pt-2">Email enviado com sucesso</span>
            </div>
            <div class="subtitle-1 grey--text text--darken-3 px-12 py-4 text-center">
                Você receberá uma mensagem no e-mail indicado, com as instruções de como redefinir a sua senha.
            </div>
            <div class="px-12">
                <div class="fluid d-flex justify-center">
                    <router-link to="/login" class="decoration-none">
                        <v-btn
                            color="#1c579a"
                            class="white--text button-primary elevation-2 mt-6"
                        >
                            VOLTAR PARA LOGIN
                        </v-btn>
                    </router-link>
                </div>
            </div>
        </v-content>
    </v-container>
    <v-snackbar
      v-model="notification.active"
      :top="true"
      :color="notification.type"
    >
      {{ notification.description }}
      <v-btn
        color="white"
        text
        @click="notification.active = false"
      >
        {{ notification.closeText }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
    data: () => ({
      notification: {
        active: false,
        description: '',
        type: '',
        closeText: ''
      },
      recoverSuccess: false,
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'Este campo é obrigatório!',
        v => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
    }),
	
    methods: {
      send () {
        if ( this.$refs.form.validate() ) {
          this.$http.put('forgot_password/', {
              username: this.email
          }).then( () => {
            this.valid = false;
            this.notification = {
              active: true,
              description: 'Instruções enviadas com sucesso para seu e-mail',
              type: 'success',
              closeText: 'Ok'
            };
            this.recoverSuccess = true;
          } ).catch( () => {
            this.showError('Erro ao solicitar uma nova senha, tente novamente.');
          } );
        }
      },
      
      showError(error) {
        this.notification = {
          active: true,
          description: error,
          type: 'error',
          closeText: 'Fechar'
        }
      }
    },
}
</script>

<style scoped>
    
</style>